var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wishlist cl-accent" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12 end-xs" }, [
        _c(
          "i",
          {
            staticClass: "material-icons p15 pointer cl-accent",
            on: { click: _vm.closeWishlistPannel }
          },
          [_vm._v("close")]
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row middle-xs px40" },
      [
        _vm.productsInWishlist.length
          ? _c("h2", { staticClass: "col-xs-12 col-sm cl-accent" }, [
              _vm._v("\n      " + _vm._s(_vm.$t("Wishlist")) + "\n    ")
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.productsInWishlist.length
          ? _c("clear-wishlist-button", {
              staticClass: "col-xs-12 col-sm mt35 mb35 end-sm",
              on: { click: _vm.clearWishlist }
            })
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    !_vm.productsInWishlist.length
      ? _c("h4", { staticClass: "cl-accent ml30" }, [
          _vm._v("\n    " + _vm._s(_vm.$t("Your wishlist is empty.")) + "\n  ")
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.productsInWishlist.length
      ? _c(
          "div",
          { staticClass: "ml30" },
          [
            _vm._v("\n    " + _vm._s(_vm.$t("Don't hesitate and")) + "\n    "),
            _c(
              "router-link",
              {
                attrs: { to: _vm.localizedRoute("/") },
                nativeOn: {
                  click: function($event) {
                    return _vm.closeWishlistPannel($event)
                  }
                }
              },
              [
                _vm._v(
                  "\n      " + _vm._s(_vm.$t("browse our catalog")) + "\n    "
                )
              ]
            ),
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("to find something beautiful for You!")) +
                "\n  "
            )
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "products" },
      _vm._l(_vm.productsInWishlist, function(wishlistProduct) {
        return _c("product", {
          key: wishlistProduct.id,
          attrs: { categoryProps: _vm.categoryProps, product: wishlistProduct }
        })
      }),
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }